<div *ngIf="afterExchange && globalService.settings.offer.show_prices_conversion"
     [ngStyle]="{'padding-left': paddingLeft, 'text-align':'left'}" class="col-xs-12">
    {{afterExchange}}
</div>
